import React from "react";
import {
  Typography,
  TextField,
  Box,
  Button,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { AddBox } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoPopover from "../../../../utils/informationButton";

const MultipleChoiceResponseComponent = (props) => {
  const { t } = useTranslation();

  const labels = props.state.formDatas?.multipleChoiceLabels || [];
  const values = props.state.formDatas?.multipleChoiceValues || [];
  const maxChoices = 6;
  const minChoices = 2;
  const canRemove = labels.length > minChoices;

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.response_multiple_choice")}
          text={t("newEnigma.response_multiple_choice_info")}
          src="/images/game-response-multiple-choices.jpeg"
        />
      </Box>

      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          marginBottom: "16px",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          className={props.classes.uploadFile}
          startIcon={<AddBox />}
          onClick={props.addMultipleChoice}
          disabled={labels.length >= maxChoices}
          style={{
            marginBottom: "16px",
          }}
          aria-label={t("newEnigma.add_multiple_choice")}
        >
          {t("newEnigma.add_multiple_choice")}
        </Button>
      </Box>

      {labels.map((label, index) => {
        const optionLabel = t("newEnigma.multipleChoice_option_label", {
          index: index + 1,
        });
        const choiceId = `multiple-choice-label-${index.toString()}`;

        return (
          <div key={choiceId}>
            <Box
              direction="row"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                flexDirection: "row",
                gap: "8px",
              }}
            >
              <TextField
                id={choiceId}
                label={optionLabel}
                required
                variant="outlined"
                size="small"
                className={props.classes.textfieldPropositions}
                onChange={(event) =>
                  props.handleMultipleChoiceLabelChange(event, index)
                }
                type="text"
                value={label}
                inputProps={{ maxLength: 31 }}
              />
              <Typography
                style={{
                  fontSize: "12px",
                  color: "#94A3B8",
                  minWidth: "42px",
                  marginTop: "10px",
                  textAlign: "right",
                }}
              >
                {(label || "").length}/31
              </Typography>

              <Checkbox
                checked={values && values.length > index ? values[index] : false}
                onChange={(event) =>
                  props.handleMultipleChoiceValueChange(event, index)
                }
                color="primary"
                style={{
                  marginTop: 14,
                }}
              />

              {index !== 0 && canRemove ? (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={(e) => props.removeMultipleChoice(e, index)}
                >
                  <DeleteIcon style={{ color: "red" }} />
                </IconButton>
              ) : (
                <Box style={{ width: "35px" }} />
              )}
            </Box>
          </div>
        );
      })}
    </>
  );
};

export default MultipleChoiceResponseComponent;

